import React, {useMemo} from 'react';
import {
  HIERARCHY_TREE_UNDEFINED_PARENT_ID,
  HierarchyNodeFlat,
  HierarchyTreeChildren,
  HierarchyTreeNode,
} from 'src/js/model/hierarchy_tree_children';

import {HierarchySyncTree} from './HierarchySyncTree';

export interface HierarchySyncContainerOwnProps {
  data: HierarchyNodeFlat[];
  hierarchyTypeId: number;
  isTogglingSeparated?: boolean;
  onNodeClick?: (node: HierarchyTreeNode) => void;
  rootId?: string | number;
  rootLabel?: string;
  showRoot?: boolean;
  tabIndex?: number;
  highlightedValues?: string[];
  getOptionDisabled?: (row: any) => boolean;
}

type Props = HierarchySyncContainerOwnProps;

export const HierarchySyncContainer: React.FC<Props> = (props) => {
  const {
    data,
    hierarchyTypeId = 0,
    isTogglingSeparated = false,
    onNodeClick,
    showRoot = false,
    tabIndex = 0,
    highlightedValues,
    getOptionDisabled,
  } = props;

  const hierarchyTree = useMemo(() => {
    return new HierarchyTreeChildren(
      HierarchyTreeChildren.buildHierarchyTree(
        data,
        HIERARCHY_TREE_UNDEFINED_PARENT_ID
      ),
      hierarchyTypeId
    );
  }, [data, hierarchyTypeId]);

  return hierarchyTree?.getNodes()?.length > 0 ? (
    <HierarchySyncTree
      key={hierarchyTypeId}
      hierarchyId={hierarchyTypeId}
      isTogglingSeparated={isTogglingSeparated}
      onNodeClick={onNodeClick}
      rootNode={hierarchyTree.getNodes()[0]}
      showRoot={showRoot}
      tabIndex={tabIndex}
      highlightedValues={highlightedValues}
      getOptionDisabled={getOptionDisabled}
    />
  ) : null;
};

HierarchySyncContainer.displayName = 'HierarchySyncContainer';
